import { Item } from 'src/app/shared/fd-form-components/fd-select/fd-select.component';

export class TefBrowserActivationPeriodModel {
  public days: Item[];
  public startDate: string;
  public endDate: string;
  public observation?: string;
}
